<template>
    <transition name="fade">
        <div v-show="toggle">
            <div
                :class="`${directionPadding} 
                    tooltip bs-tooltip-${direction} 
                    d-flex 
                    ${direction === 'right' || direction === 'left' ? null : 'flex-column'} 
                    align-items-center`"
            
            >
                <div :style="`--color-arrow: ${colorPrimary}`" :class="`arrow ${directionPadding} shadow-lg`"></div>
                <div :style="`background-color: ${colorPrimary}; color: ${colorSecondary}`" class="tooltip-inner shadow-lg">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'BaseTooltip',
    props: {
        colorPrimary: {
            type: String,
            required: false,
            default: '#000',
        },
        colorSecondary: {
            type: String,
            required: false,
            default: '#fff',
        },
        direction: {
            type: String,
            required: true,
            default: 'top',
            description: '(top, bottom, right, left)',
        },
        toggle: {
            type: Boolean,
            required: true,
        },
        padding: {
            type: Number,
            required: false,
        }
    },

    computed: {
        directionPadding(){
            if (this.direction === 'top') {
                return `pb-${this.padding}`;
            }else if (this.direction === 'bottom') {
                return `pt-${this.padding}`;
            }else if (this.direction === 'right') {
                return `pl-${this.padding}`
            }else if (this.direction === 'left') {
                return `pr-${this.padding}`
            }
        }
    }
}
</script>

<style scoped>
.tooltip {
    opacity: 1;
}

.bs-tooltip-bottom .arrow::before {
    border-bottom-color: var(--color-arrow);
}

.bs-tooltip-top .arrow::before {
    border-top-color: var(--color-arrow);
}

.bs-tooltip-right .arrow::before {
    border-right-color: var(--color-arrow);
}

.bs-tooltip-left .arrow::before {
    border-left-color: var(--color-arrow);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>